$(window).on('load', () => {
	console.log('Loaded!');
});
